@if (!isSameDateSamePerson) {
    <table>
        @for (sentInfo of sentInfos; track sentInfo) {
            <tr>
                <td class="header">Site:</td>
                <td style="white-space: nowrap">{{ getValue(sentInfo, 'siteName', 20) }},</td>
                <td class="header">Parcel:</td>
                <td>{{ getValue(sentInfo, 'parcelAccountNumber', 20) }},</td>
                <td class="header">By:</td>
                <td>{{ getUserName(sentInfo, 15) }},</td>
                <td class="header">Sent:</td>
                <td>{{ sentInfo.sentDate | date: 'MM/dd/yyyy' }}</td>
            </tr>
        }
    </table>
}
@if (isSameDateSamePerson) {
    <div>
        All parcels sent by this user on date indicated.
    </div>
}
